"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var blob_to_hash_1 = require("blob-to-hash");
exports.default = (function (file, encoding) {
    if (encoding === void 0) { encoding = 'hex'; }
    return blob_to_hash_1.default('sha1', file, encoding);
});
